import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21 12V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V12H21ZM16 3C16.5523 3 17 3.44772 17 4V5H19C20.1046 5 21 5.89543 21 7V10H3V7C3 5.89543 3.89543 5 5 5H7V4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4V5H15V4C15 3.44772 15.4477 3 16 3Z" })
});
export default SvgCalendarFill;
